import config from './index';
export default config;